import {
	getStaffMe,
	refreshStaffSession,
} from "@/features/auth/api/auth-staff";
import {
	applyStaffAccess,
	applyStaffAccount,
	clearSession,
	getAccessToken,
	getRefreshToken,
	isAuthenticated,
} from "@/features/auth/lib/auth-store";

export async function hydrateStaffSession(): Promise<boolean> {
	const accessToken = getAccessToken();
	const refreshToken = getRefreshToken();

	if (!accessToken && !refreshToken) {
		return false;
	}

	if (accessToken) {
		try {
			applyStaffAccount(await getStaffMe(accessToken));
			return true;
		} catch {
			// Access lapsed — try the refresh token next.
		}
	}

	if (!refreshToken) {
		clearSession();
		return false;
	}

	try {
		applyStaffAccess(await refreshStaffSession(refreshToken));
		return isAuthenticated();
	} catch {
		clearSession();
		return false;
	}
}
